import client from "@/lib/api";

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await client.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}
